import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMilibooPomMin = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 1080 1080",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("mask", {
		id: "cutout",
		x: 0,
		y: 0,
		width: 1080,
		height: 1080,
		maskUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 1080,
			height: 1080,
			rx: 81.82,
			ry: 81.82,
			fill: "#ffffff"
		}), /* @__PURE__ */ _jsxs("g", {
			fill: "#000000",
			children: [/* @__PURE__ */ _jsx("path", { d: "M762.69,638.97v-296.57c0-21.84-8.36-41.12-25.32-57.73-16.84-16.61-36.36-24.98-58.43-24.98s-59.24,9.18-99.44,27.65c6.39,18.94,9.64,37.41,9.64,55.18v296.57h-92.58v-295.99c.7-21.84-7.67-41.12-24.28-57.73-16.61-16.61-36.24-24.98-58.55-24.98s-59.48,8.02-96.42,24.16v360.35h-98.28V234.25l98.97-35.31c39.73-12.66,73.3-18.94,100.83-18.94,45.42,0,84.1,13.48,116.4,40.54,68.89-26.95,119.54-40.54,151.71-40.54,48.79,0,89.91,15.8,123.25,47.4,33.34,31.6,49.95,70.05,50.76,115.47v295.99h-98.28v.12h0Z" }), /* @__PURE__ */ _jsx("text", {
				x: 540,
				y: 900,
				textAnchor: "middle",
				fontSize: 260,
				fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Montserrat', sans-serif",
				fontWeight: 850,
				children: "\n          POM\n        "
			})]
		})]
	}) }), /* @__PURE__ */ _jsx("rect", {
		width: 1080,
		height: 1080,
		rx: 81.82,
		ry: 81.82,
		fill: "currentColor",
		mask: "url(#cutout)"
	})]
});
export default SvgMilibooPomMin;
